__turbopack_context__.v({
  "accessSelect": "AddShareForm-module__yi-dXa__accessSelect",
  "fields": "AddShareForm-module__yi-dXa__fields",
  "root": "AddShareForm-module__yi-dXa__root",
  "typeahead": "AddShareForm-module__yi-dXa__typeahead",
});
